//Modal for confirmation of multiple deleting experiences

import React from 'react';
import { Button, Modal, ModalHeader, ModalFooter } from 'reactstrap';
import {connect} from "react-redux";
import { bindActionCreators } from 'redux';
import {setDeleteExperienceModalStatus} from "../../store/experiences";

class ConfirmExperienceDeleteModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };

    }

    static getDerivedStateFromProps(nextProps, prevState){
        let update = {};
        if(prevState.show !== nextProps.show_delete_experience_modal) {
            update.show = nextProps.show_delete_experience_modal
        }
        return Object.keys(update).length ? update : null;
    }

    toggle = () => {
        this.setState(prevState => ({
            show: !prevState.show
        }));
        this.props.setDeleteExperienceModalStatus(!this.props.show_delete_experience_modal)
    }

    handleDelete = () => {
        this.props.handleDelete()
        this.setState({show:false})
        this.props.setDeleteExperienceModalStatus(false)
    }

    render() {
        let message = this.props.isMultipleDelete ? 'Are you sure you want to delete these experiences?' : 'Are you sure you want to delete this experience?';
        return (
            <div>
                <Modal isOpen={this.state.show} toggle={this.toggle} className="modal-resource-delete" centered>
                    <ModalHeader toggle={this.toggle}>{message}</ModalHeader>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleDelete}>Yes</Button>
                        <Button color="secondary" onClick={this.toggle}>No</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    experience_item: state.experiences.experience_item,
    show_delete_experience_modal: state.experiences.show_delete_experience_modal
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setDeleteExperienceModalStatus
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmExperienceDeleteModal);